// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Profile_wrapper__REOou","desc":"Profile_desc__e_jk7","avatarWrapper":"Profile_avatarWrapper__xt_Qz"};